<template>
  <div v-if="currently_recording.length > 0" class="form-group">
    <div class="kt-notification kt-notification--fit">
      <div v-for="(recording, index) in currently_recording" :key="index" class="kt-notification__item">
        <div class="kt-notification__item-icon">
          <i class="flaticon-stopwatch kt-font-brand" />
        </div>
        <div class="kt-notification__item-details">
          <div class="kt-notification__item-title">
            <strong>Stream Name : </strong> {{ recording.streamname }}
          </div>
          <div class="kt-notification__item-time">
            <strong>Show Name : </strong> {{ recording.showname }}
          </div>
          <div class="kt-notification__item-title">
            <span> {{ broadcastStartFormatted(recording) }} - {{ broadcastStopFormatted(recording) }} </span>
            <div v-if="recording.progress < 99" class="progress">
              <div class="progress-bar progress-bar-striped progress-bar-animated bg-success"
                   role="progressbar" :aria-valuenow="recording.progress"
                   aria-valuemin="0" aria-valuemax="100"
                   :style="`width: ${recording.progress}%`" />
            </div>
            <div v-else>
              <span class="kt-badge kt-badge--inline kt-badge--success">Recording Completed @ {{ broadcastStopFormatted(recording) }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="alert alert-secondary" role="alert">
      <div class="alert-text">
        Finished Recordings will become available as items few minutes later.
      </div>
    </div>
  </div>
  <div v-else>
    <div class="alert alert-ss-primary" role="alert">
      <div class="alert-text">
        {{ no_data_message }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "pinia";
import useRecorderStore from "VueStore/app/recorder";

export default {
  data: () => ({
    api_error: false,
  }),
  asyncComputed: {
    current: {
      async get() {
        try {
          const res = await axios.get(`/api/v1/recorder/recording`);
          if (res.success) {
            this.api_error = false;
            return res.data;
          } else {
            this.api_error = true;
            return [];
          }
        } catch (err) {
          window.handleAxiosError(err);
        }
      },
    },
  },
  computed: {
    ...mapState(useRecorderStore, ['now']),
    currently_recording() {
      let current = _.filter(this.current, o => !o.status);

      current = _.take(current, 50);

      _.forEach(current,
        recording => recording.progress = this.calculateRecordingProgress(recording));

      return current;
    },
    no_data_message() {
      return this.api_error ? 'Currently Unavailable!' : 'Nothing is currently recording!';
    },
  },
  methods: {
    calculateRecordingProgress(recording) {
      return (this.now - recording.broadcaststart) / (recording.broadcaststop - recording.broadcaststart) * 100;
    },

    broadcastStartFormatted(recording) {
      return moment.unix(recording.broadcaststart).format('DD/MM/YYYY hh:mm:ss') + ' @ ' + recording.timezone;
    },

    broadcastStopFormatted(recording) {
      return moment.unix(recording.broadcaststop).format('DD/MM/YYYY hh:mm:ss') + ' @ ' + recording.timezone;
    },

  },
};
</script>

<style lang="scss" scoped>
  .kt-notification .kt-notification__item:after {
    display:none;
  }
</style>
